<template>
    <div class="content-wrapper">
        <section class="content-header">
            <h1>
                {{ title }}
            </h1>
            <ol class="breadcrumb">
                <li>
                    <router-link :to="{ name: 'dashboard' }">
                        <i class="fa fa-dashboard"></i> Home
                    </router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'review-index'}">
                        Explore Review
                    </router-link>
                </li>
                <li class="active">
                    <span>Create</span>
                </li>
            </ol>
        </section>
        <section class="content">
            <div class="row">
                <div class="col-md-6">
                    <div class="box box-info">
                        <div class="box-header with-border">
                            <!-- <h3 class="box-title">Add Review</h3> -->
                        </div>
                        <form id="review-form" class="form-horizontal" @submit.prevent="submit">
                            <div class="box-body" style="overflow: unset;">
                                <!-- <div v-if="error" class="alert alert-danger">
                                    <a class="close"
                                        @click="error = false">
                                        &times;
                                    </a>
                                    {{ error }}
                                </div> -->
                                <div class="form-group">
                                    <label for="name" class="col-sm-12">Product Type
                                        <span class="req">*</span>
                                    </label>
                                    <div class="col-sm-12">
                                        <v-select
                                        name="product"
                                        id="product-name"
                                        :options="list.type"
                                        placeholder="Select Product Type"
                                        @input="fetchlistProducts"
                                        v-model="flaging">
                                        </v-select>
                                    </div>
                                </div>
                                <div v-if="flaging" class="form-group">
                                    <label for="name" class="col-sm-12">Product Name 
                                        <span class="req">*</span>
                                    </label>
                                    <div class="col-sm-12">
                                        <v-select
                                        name="product"
                                        id="product-name"
                                        :options="list.product"
                                        placeholder="Select Product Name"
                                        v-model="review.product_name">
                                        </v-select>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="name" class="col-sm-12">Account Name 
                                        <span class="req">*</span>
                                    </label>
                                    <div class="col-sm-12">
                                        <input
                                        type="text"
                                        class="form-control"
                                        id="account-name"
                                        placeholder="Input Account Name"
                                        v-model="review.name">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="name" class="col-sm-12">Review Description
                                        <span class="req">*</span>
                                    </label>
                                    <div class="col-sm-12">
                                        <textarea
                                        class="form-control"
                                        id="review-description"
                                        placeholder="Input Review Description"
                                        maxlength="1000"
                                        v-model="review.description">
                                        </textarea>
                                    </div>
                                </div>
                                <box id="gallery" title="Insert Photo*">
                                    <button class="btn btn-sm btn-block btn-info"
                                    @click.prevent="showModal('gallery')">
                                    Choose File
                                    </button>
                                    <div>
                                        <h4>
                                            Upload Attention
                                        </h4>
                                        <p>
                                            Allowed extension only for PNG, Jpg/Jpeg. file with max size 10000KB
                                        </p>
                                    </div>
                                    <div class="image-gallery">
                                        <template v-if="review.gallery">
                                            <div class="image-item img-thumbnail img-responsive"
                                            v-for="(image, index) in review.gallery"
                                            :style="{ backgroundImage: `url('${getSize(image.url, 'thumb')}')` }"
                                            :key="index">
                                            </div>
                                        </template>
                                    </div>
                                </box>
                                <box id="video" title="Insert Video">
                                    <button class="btn btn-sm btn-block btn-info"
                                    @click.prevent="showModal('video')">
                                    Choose File
                                    </button>
                                    <div>
                                        <h4>
                                            Upload Attention
                                        </h4>
                                        <p>
                                            Allowed extension only for Mp4, Mov. file with max size 100000KB
                                        </p>
                                    </div>
                                    <div class="image-gallery">
                                        <template v-if="review.video.length">
                                            <video width="320" height="240" controls>
                                                <source :src="review.video" type="video/mp4">
                                            </video>
                                        </template>
                                    </div>
                                </box>
                            </div>
                            
                        </form>
                    </div>
                </div>
                <div class="col-md-6" v-if="review.product_name">
                    <label for="name" class="col-sm-12 mt-5">Detail Product </label>
                    <div>
                        <img class="image-review" :src="review.product_name.image" alt="image-product">
                    </div>
                    <div class="review-list row">
                        <span class="review-detail-product col-md-3">
                            Product Name 
                        </span>
                        <span class="col-md-7">
                            : {{ review.product_name.label }}
                        </span>
                    </div>
                    <div class="review-list row">
                        <span class="review-detail-product col-md-3">
                            Merchant 
                        </span>
                        <span class="col-md-7">
                            : {{ review.product_name.merchant }}
                        </span>
                    </div>
                    <div class="review-list row" v-if="review.product_name">
                        <span class="review-detail-product col-md-3">
                            Destination 
                        </span>
                        <span class="col-md-7">
                            : {{ review.product_name.destination[review.product_name.destination.length-1].name+', '+ review.product_name.destination[review.product_name.destination.length-2].name }}
                        </span>
                    </div>
                </div>
                <transition name="slideDown">
                    <modal title="Select Gallery Images"
                    v-if="show.gallery">
                    <FileGallery
                        type="gallery"
                        :is-multiple="true"
                        :selected="review.gallery"
                        :is-review="true"
                        @update-images="setImage" />
                    </modal>
                </transition>
                <transition name="slideDown">
                    <modal title="Select Video"
                    v-if="show.video">
                    <VideoUpload
                        type="Video Upload"
                        :is-multiple="false"
                        :selected="review.video"
                        :is-review="true"
                        @update-video="setVideo" />
                    </modal>
                </transition>
            </div>
            <div class="box-footer">
                <button @click="create" type="submit" class="btn btn-info pull-right" v-if="isCreate">Create</button>
                <button @click="submit" type="submit" class="btn btn-info pull-right" v-else>Update</button>
                <a class="btn btn-default" @click.prevent="cancel">Cancel</a>
            </div>
        </section>
    </div>
</template>
<script>
import Common from '@/mixins/Common';
import bus from '@/utils/bus';
import Modal from '@/components/modules/common/Modal';
import FileGallery from '@/components/modules/common/FileGallery';
import VideoUpload from '@/components/modules/common/VideoUpload';
import Box from '@/components/modules/common/Box';

export default {
    name: 'ReviewForm',

    mixins: [Common],

    data() {
        return {
            title: 'Add Review',

            review: {
                product_name: null,
                description: null,
                name: null,
                gallery: null,
                video: [],
            },
            error: {
                product: null,
            },
            flaging: null,
            list: {
                product: [],
                type: [
                    {
                        label: 'Explore Product',
                        value: 'explore',
                    },
                    {
                        label: 'Tour Product',
                        value: 'tour',
                    },
                ],
            },
            show: {
                gallery: false,
                video: false,
            },
        };
    },
    components: {
        Box,
        FileGallery,
        VideoUpload,
        Modal,
    },

    props: {
        isCreate: {
            type: Boolean,
            required: false,
        },
    },
    methods: {
        showModal(modal) {
            this.$store.commit('SET_MODAL', modal);
            this.show[modal] = true;
            document.body.classList.add('locked');
        },
        closeModals() {
            document.body.classList.remove('locked');
            Object.keys(this.show).forEach((modal) => {
                this.show[modal] = false;
            });
        },
        setImage(payload) {
            if (payload.target === 'gallery') {
                this.review.gallery = payload.images;
            }
        },
        setVideo(payload) {
            this.review.video = [];
            if (payload.target === 'Video Upload') {
                setTimeout(() => {
                    this.review.video = payload.video;
                }, 1000);
            }
        },
        validate() {
            if (!this.review.product_name) {
                this.$swal('Product Name required', 'Please fill Product name to continue', 'warning');
                return false;
            }
            if (!this.review.name) {
                this.$swal('Account Name required', 'Please fill Account name to continue', 'warning');
                return false;
            }
            if (!this.review.description) {
                this.$swal('Description is required', 'Please fill Description to continue', 'warning');
                return false;
            }
            if (!this.review.gallery) {
                this.$swal('Image is required', 'Please fill image to continue', 'warning');
                return false;
            }
            // if (!this.review.video) {
            //     this.$swal('Video is required', 'Please fill Video to continue', 'warning');
            //     return false;
            // }
            return true;
        },
        create() {
            const validation = this.validate();
            if (!validation) return;
            this.$swal({
                title: 'Confirmation',
                text: 'Are you sure want to submit this review?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#666',
                confirmButtonText: 'Yes',
            }).then((result) => {
                if (result.value) {
                    this.submit();
                }
            });
        },
        submit() {
            const data = this.generateData();

            this.axios.post('review/backoffice', JSON.stringify(data))
            .then(() => {
                bus.$emit('destroy-editor');
                this.$swal({
                    title: 'Created',
                    text: 'Review has been created',
                    type: 'success',
                    timer: 3000,
                });

                this.$router.go(-1);
            })
            .catch((error) => {
                console.log('error', error);

                if (error.response) {
                    this.errors = error.response.data.errors;
                }

                if (error) {
                    this.$swal({
                    title: 'Create Failed!',
                    text: 'Failed to create review',
                    type: 'warning',
                    timer: 5000,
                    });
                }
            });
        },
        cancel() {
            bus.$emit('destroy-editor');
            this.$router.go(-1);
        },
        generateData() {
            /* eslint-disable */
            const {
                product_name,
                name,
                gallery,
                video,
                description,
            } = this.review;

            const data = {};
            data.product_id = product_name.value;
            data.product_name = product_name.label;
            data.name = name;
            data.photos = (gallery) ? gallery.map(item => (item.url)) : null;
            if (video.length > 0) {
                data.videos = [video];
            }
            data.description = description;

            return data;
        },
        async fetchlistProducts() {
            this.review.product_name = null;
            this.list.product = [];
            try {
                const response = await this.axios.get(`/products?b2b_type=internal&perpage=1000&page=1&flaging=${this.flaging.value}`);
                const products = response.data.data;
                if (products !== null) {
                products.forEach((item) => {
                    this.list.product.push({ 
                    label: item.name, 
                    value: item.id,
                    image: item.image_url,
                    merchant: item.merchant.name,
                    destination: item.destinations,
                    });
                });
                }
            } catch (error) {
                console.log(error);
                if (error.response) {
                this.error.product = error.response.data.errors;
                }
            }
        },
    },
    // created() {
    //     this.fetchlistProducts();
    // },
    mounted() {
        bus.$on('close-modal', () => {
            this.closeModals();
        });
    },

    destroyed() {
        bus.$off('close-modal');
    },
};
</script>
<style lang="scss" scoped>
    .image-gallery {
    display: flex;
    flex-wrap: wrap;
    
    .image-item {
      position: relative;
      display: inline-block;
      width: calc(100% / 5 - 1.5rem);
      margin: 0.75rem;
      background: transparent center no-repeat;
      background-size: cover;

      &::after {
        content: '';
        display: block;
        padding-bottom: 100%;
      }
    }
}
    .image-review {
        width: 350px;
        display: flex;
        margin: 30px 0 20px 20px;
    }
    .review-list {
        margin: 15px 0 15px 10px;
        .review-detail-product {
            font-weight: 700;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/modules/review/Form.vue